export default __webpack_public_path__ + "static/media/banner_mobile.1adca794.png";